import {
  canAccessTool,
  canEditJob,
  canMutateTask,
  getCurrentUserPermissions,
  hasAllPermissions,
  hasAnyPermission,
  hasPermission,
  hasRole,
  isPowerAdmin,
} from '../services/authorization';

/**
 ** Helper Functions that get values from the state
 */
const getters = {
  isPowerAdmin(state) {
    return isPowerAdmin(state.currentUser);
  },

  currentUserPermissions(state) {
    return getCurrentUserPermissions(state);
  },

  hasRole: (state) => (roles) => {
    return hasRole(state.currentUser, roles);
  },

  hasPermission: (state) => (permission) => {
    return hasPermission(state, permission);
  },

  hasAnyPermission: (state) => (permissions) => {
    return hasAnyPermission(state, permissions);
  },

  hasAllPermissions: (state) => (permissions) => {
    return hasAllPermissions(state, permissions);
  },

  canAccessTool: (state) => (tool) => {
    return canAccessTool(state, tool);
  },

  canEditJob:
    (state) =>
    (job, tool, options = {}) => {
      return canEditJob(state, { job, tool, ...options });
    },

  canMutateTask:
    (state) =>
    (job, tool, options = {}) => {
      return canMutateTask(state, { job, tool, ...options });
    },

  siteName(state) {
    return (id) => {
      let siteName = '';
      state.sites.filter((site) => {
        if (site._id === id) {
          siteName = site.siteName;
        }
      });
      return siteName;
    };
  },
};

export default getters;
